import React from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { primary_s5_l70 } from '../lib/colors';

const getStyles = (primaryColor, uiVariantInputText) => css`
  .form-control {
    border-radius: ${uiVariantInputText === '1'
      ? '12px'
      : uiVariantInputText === '3'
      ? '30px'
      : 0};

    &:focus {
      border-color: ${primaryColor};
    }
  }
  .help-block {
    color: ${primary_s5_l70(primaryColor)};
  }
`;

const TextFieldWithLabel = ({
  id,
  input,
  label,
  placeholder,
  type,
  meta: { asyncValidating, touched, error },
  primaryColor,
  uiVariantInputText,
}) => {
  return (
    <div
      css={getStyles(primaryColor, uiVariantInputText)}
      className={`form-group ${touched && error && 'error'}`}
    >
      <label htmlFor={id} className="col-sm-4 control-label">
        {label}
      </label>
      <div className="col-sm-8">
        <input
          {...input}
          id={id}
          placeholder={placeholder}
          type={type}
          className="form-control"
        />
        {touched && error && <div className="error-text">{error}</div>}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputText: state.store.data.uiVariants.inputText,
});

export default connect(mapStateToProps)(TextFieldWithLabel);
